export interface ParcelActionResult {
  allowed: boolean;
  messageKey: string;
  updatePDate: boolean;
}

const rules = [
  // ROLE_ADMIN rules
  {
    role: 'ROLE_ADMIN',
    restituted: 'No',
    personalizedDate: 'Unset',
    defaultWeek: 'Unset',
    outsideCampaign: null,
    updatePDate: false,
    suspend: true,
    reactivate: true,
    msgSuspend: 'suspend.success',
    msgReactivate: 'reactivate.success',
  },
  {
    role: 'ROLE_ADMIN',
    restituted: 'No',
    personalizedDate: 'Unset',
    defaultWeek: 'Past',
    outsideCampaign: null,
    updatePDate: false,
    suspend: true,
    reactivate: true,
    msgSuspend: 'suspend.success',
    msgReactivate: 'reactivate.success',
  },
  {
    role: 'ROLE_ADMIN',
    restituted: 'No',
    personalizedDate: 'Unset',
    defaultWeek: 'Future',
    outsideCampaign: null,
    updatePDate: false,
    suspend: true,
    reactivate: true,
    msgSuspend: 'suspend.success',
    msgReactivate: 'reactivate.success',
  },
  {
    role: 'ROLE_ADMIN',
    restituted: 'No',
    personalizedDate: 'Past',
    defaultWeek: 'Unset',
    outsideCampaign: null,
    updatePDate: false,
    suspend: true,
    reactivate: true,
    msgSuspend: 'suspend.success',
    msgReactivate: 'reactivate.success',
  },
  {
    role: 'ROLE_ADMIN',
    restituted: 'No',
    personalizedDate: 'Past',
    defaultWeek: 'Past',
    outsideCampaign: null,
    updatePDate: false,
    suspend: true,
    reactivate: true,
    msgSuspend: 'suspend.success',
    msgReactivate: 'reactivate.success',
  },
  {
    role: 'ROLE_ADMIN',
    restituted: 'No',
    personalizedDate: 'Past',
    defaultWeek: 'Future',
    outsideCampaign: null,
    updatePDate: false,
    suspend: true,
    reactivate: true,
    msgSuspend: 'suspend.success',
    msgReactivate: 'reactivate.success',
  },
  {
    role: 'ROLE_ADMIN',
    restituted: 'No',
    personalizedDate: 'Future',
    defaultWeek: 'Unset',
    outsideCampaign: null,
    updatePDate: false,
    suspend: true,
    reactivate: true,
    msgSuspend: 'suspend.success',
    msgReactivate: 'reactivate.success',
  },
  {
    role: 'ROLE_ADMIN',
    restituted: 'No',
    personalizedDate: 'Future',
    defaultWeek: 'Past',
    outsideCampaign: null,
    updatePDate: false,
    suspend: true,
    reactivate: true,
    msgSuspend: 'suspend.success',
    msgReactivate: 'reactivate.success',
  },
  {
    role: 'ROLE_ADMIN',
    restituted: 'No',
    personalizedDate: 'Future',
    defaultWeek: 'Future',
    outsideCampaign: null,
    updatePDate: false,
    suspend: true,
    reactivate: true,
    msgSuspend: 'suspend.success',
    msgReactivate: 'reactivate.success',
  },
  {
    role: 'ROLE_ADMIN',
    restituted: 'Yes',
    personalizedDate: 'Unset',
    defaultWeek: 'Unset',
    outsideCampaign: null,
    updatePDate: false,
    suspend: true,
    reactivate: true,
    msgSuspend: 'suspend.success',
    msgReactivate: 'reactivate.success',
  },
  {
    role: 'ROLE_ADMIN',
    restituted: 'Yes',
    personalizedDate: 'Unset',
    defaultWeek: 'Past',
    outsideCampaign: null,
    updatePDate: false,
    suspend: true,
    reactivate: true,
    msgSuspend: 'suspend.success',
    msgReactivate: 'reactivate.success',
  },
  {
    role: 'ROLE_ADMIN',
    restituted: 'Yes',
    personalizedDate: 'Unset',
    defaultWeek: 'Future',
    outsideCampaign: null,
    updatePDate: false,
    suspend: true,
    reactivate: true,
    msgSuspend: 'suspend.success',
    msgReactivate: 'reactivate.success',
  },
  {
    role: 'ROLE_ADMIN',
    restituted: 'Yes',
    personalizedDate: 'Past',
    defaultWeek: 'Unset',
    outsideCampaign: null,
    updatePDate: false,
    suspend: true,
    reactivate: true,
    msgSuspend: 'suspend.success',
    msgReactivate: 'reactivate.success',
  },
  {
    role: 'ROLE_ADMIN',
    restituted: 'Yes',
    personalizedDate: 'Past',
    defaultWeek: 'Past',
    outsideCampaign: null,
    updatePDate: false,
    suspend: true,
    reactivate: true,
    msgSuspend: 'suspend.success',
    msgReactivate: 'reactivate.success',
  },
  {
    role: 'ROLE_ADMIN',
    restituted: 'Yes',
    personalizedDate: 'Past',
    defaultWeek: 'Future',
    outsideCampaign: null,
    updatePDate: false,
    suspend: true,
    reactivate: true,
    msgSuspend: 'suspend.success',
    msgReactivate: 'reactivate.success',
  },
  {
    role: 'ROLE_ADMIN',
    restituted: 'Yes',
    personalizedDate: 'Future',
    defaultWeek: 'Unset',
    outsideCampaign: null,
    updatePDate: false,
    suspend: true,
    reactivate: true,
    msgSuspend: 'suspend.success',
    msgReactivate: 'reactivate.success',
  },
  {
    role: 'ROLE_ADMIN',
    restituted: 'Yes',
    personalizedDate: 'Future',
    defaultWeek: 'Past',
    outsideCampaign: null,
    updatePDate: false,
    suspend: true,
    reactivate: true,
    msgSuspend: 'suspend.success',
    msgReactivate: 'reactivate.success',
  },
  {
    role: 'ROLE_ADMIN',
    restituted: 'Yes',
    personalizedDate: 'Future',
    defaultWeek: 'Future',
    outsideCampaign: null,
    updatePDate: false,
    suspend: true,
    reactivate: true,
    msgSuspend: 'suspend.success',
    msgReactivate: 'reactivate.success',
  },

  // ROLE_NEGOCE rules
  {
    role: 'ROLE_NEGOCE',
    restituted: 'No',
    personalizedDate: 'Unset',
    defaultWeek: 'Unset',
    outsideCampaign: null,
    updatePDate: false,
    suspend: true,
    reactivate: true,
    msgSuspend: 'suspend.success',
    msgReactivate: 'reactivate.success',
  },
  {
    role: 'ROLE_NEGOCE',
    restituted: 'No',
    personalizedDate: 'Unset',
    defaultWeek: 'Past',
    outsideCampaign: true,
    updatePDate: false,
    suspend: false,
    reactivate: false,
    msgSuspend: 'suspend.error.pastWeek',
    msgReactivate: 'reactivate.error.campaign',
  },
  {
    role: 'ROLE_NEGOCE',
    restituted: 'No',
    personalizedDate: 'Unset',
    defaultWeek: 'Past',
    outsideCampaign: false,
    updatePDate: true,
    suspend: false,
    reactivate: true,
    msgSuspend: 'suspend.error.pastWeek',
    msgReactivate: 'reactivate.dateUnset.success',
  },
  {
    role: 'ROLE_NEGOCE',
    restituted: 'No',
    personalizedDate: 'Unset',
    defaultWeek: 'Future',
    outsideCampaign: null,
    updatePDate: false,
    suspend: true,
    reactivate: true,
    msgSuspend: 'suspend.success',
    msgReactivate: 'reactivate.success',
  },
  {
    role: 'ROLE_NEGOCE',
    restituted: 'No',
    personalizedDate: 'Past',
    defaultWeek: 'Unset',
    outsideCampaign: true,
    updatePDate: false,
    suspend: false,
    reactivate: false,
    msgSuspend: 'suspend.error.pastDate',
    msgReactivate: 'reactivate.error.campaign',
  },
  {
    role: 'ROLE_NEGOCE',
    restituted: 'No',
    personalizedDate: 'Past',
    defaultWeek: 'Unset',
    outsideCampaign: false,
    updatePDate: true,
    suspend: false,
    reactivate: true,
    msgSuspend: 'suspend.error.pastDate',
    msgReactivate: 'reactivate.dateUnset.success',
  },
  {
    role: 'ROLE_NEGOCE',
    restituted: 'No',
    personalizedDate: 'Past',
    defaultWeek: 'Past',
    outsideCampaign: true,
    updatePDate: false,
    suspend: false,
    reactivate: false,
    msgSuspend: 'suspend.error.pastDateWeek',
    msgReactivate: 'reactivate.error.campaign',
  },
  {
    role: 'ROLE_NEGOCE',
    restituted: 'No',
    personalizedDate: 'Past',
    defaultWeek: 'Past',
    outsideCampaign: false,
    updatePDate: true,
    suspend: false,
    reactivate: true,
    msgSuspend: 'suspend.error.pastDateWeek',
    msgReactivate: 'reactivate.dateUnset.success',
  },
  {
    role: 'ROLE_NEGOCE',
    restituted: 'No',
    personalizedDate: 'Past',
    defaultWeek: 'Future',
    outsideCampaign: true,
    updatePDate: false,
    suspend: false,
    reactivate: false,
    msgSuspend: 'suspend.error.pastDate',
    msgReactivate: 'reactivate.error.campaign',
  },
  {
    role: 'ROLE_NEGOCE',
    restituted: 'No',
    personalizedDate: 'Past',
    defaultWeek: 'Future',
    outsideCampaign: false,
    updatePDate: true,
    suspend: false,
    reactivate: true,
    msgSuspend: 'suspend.error.pastDate',
    msgReactivate: 'reactivate.dateUnset.success',
  },
  {
    role: 'ROLE_NEGOCE',
    restituted: 'No',
    personalizedDate: 'Future',
    defaultWeek: 'Unset',
    outsideCampaign: null,
    updatePDate: false,
    suspend: true,
    reactivate: true,
    msgSuspend: 'suspend.success',
    msgReactivate: 'reactivate.success',
  },
  {
    role: 'ROLE_NEGOCE',
    restituted: 'No',
    personalizedDate: 'Future',
    defaultWeek: 'Past',
    outsideCampaign: null,
    updatePDate: false,
    suspend: true,
    reactivate: true,
    msgSuspend: 'suspend.success',
    msgReactivate: 'reactivate.success',
  },
  {
    role: 'ROLE_NEGOCE',
    restituted: 'No',
    personalizedDate: 'Future',
    defaultWeek: 'Future',
    outsideCampaign: null,
    updatePDate: false,
    suspend: true,
    reactivate: true,
    msgSuspend: 'suspend.success',
    msgReactivate: 'reactivate.success',
  },
  {
    role: 'ROLE_NEGOCE',
    restituted: 'Yes',
    personalizedDate: 'Unset',
    defaultWeek: 'Unset',
    outsideCampaign: null,
    updatePDate: false,
    suspend: false,
    reactivate: false,
    msgSuspend: 'suspend.error.restituted',
    msgReactivate: 'reactivate.error.restituted',
  },
  {
    role: 'ROLE_NEGOCE',
    restituted: 'Yes',
    personalizedDate: 'Unset',
    defaultWeek: 'Past',
    outsideCampaign: null,
    updatePDate: false,
    suspend: false,
    reactivate: false,
    msgSuspend: 'suspend.error.restituted.pastWeek',
    msgReactivate: 'reactivate.error.restituted.pastWeek',
  },
  {
    role: 'ROLE_NEGOCE',
    restituted: 'Yes',
    personalizedDate: 'Unset',
    defaultWeek: 'Future',
    outsideCampaign: null,
    updatePDate: false,
    suspend: false,
    reactivate: false,
    msgSuspend: 'suspend.error.restituted',
    msgReactivate: 'reactivate.error.restituted',
  },
  {
    role: 'ROLE_NEGOCE',
    restituted: 'Yes',
    personalizedDate: 'Past',
    defaultWeek: 'Unset',
    outsideCampaign: null,
    updatePDate: false,
    suspend: false,
    reactivate: false,
    msgSuspend: 'suspend.error.restituted.pastWeek',
    msgReactivate: 'reactivate.error.restituted.pastWeek',
  },
  {
    role: 'ROLE_NEGOCE',
    restituted: 'Yes',
    personalizedDate: 'Past',
    defaultWeek: 'Past',
    outsideCampaign: null,
    updatePDate: false,
    suspend: false,
    reactivate: false,
    msgSuspend: 'suspend.error.restituted.pastWeek',
    msgReactivate: 'reactivate.error.restituted.pastWeek',
  },
  {
    role: 'ROLE_NEGOCE',
    restituted: 'Yes',
    personalizedDate: 'Past',
    defaultWeek: 'Future',
    outsideCampaign: null,
    updatePDate: false,
    suspend: false,
    reactivate: false,
    msgSuspend: 'suspend.error.restituted.pastWeek',
    msgReactivate: 'reactivate.error.restituted.pastWeek',
  },
  {
    role: 'ROLE_NEGOCE',
    restituted: 'Yes',
    personalizedDate: 'Future',
    defaultWeek: 'Unset',
    outsideCampaign: null,
    updatePDate: false,
    suspend: false,
    reactivate: false,
    msgSuspend: 'suspend.error.restituted',
    msgReactivate: 'reactivate.error.restituted',
  },
  {
    role: 'ROLE_NEGOCE',
    restituted: 'Yes',
    personalizedDate: 'Future',
    defaultWeek: 'Past',
    outsideCampaign: null,
    updatePDate: false,
    suspend: false,
    reactivate: false,
    msgSuspend: 'suspend.error.restituted',
    msgReactivate: 'reactivate.error.restituted',
  },
  {
    role: 'ROLE_NEGOCE',
    restituted: 'Yes',
    personalizedDate: 'Future',
    defaultWeek: 'Future',
    outsideCampaign: null,
    updatePDate: false,
    suspend: false,
    reactivate: false,
    msgSuspend: 'suspend.error.restituted',
    msgReactivate: 'reactivate.error.restituted',
  },

  // ROLE_MANAGER rules
  {
    role: 'ROLE_MANAGER',
    restituted: 'No',
    personalizedDate: 'Unset',
    defaultWeek: 'Unset',
    outsideCampaign: null,
    updatePDate: false,
    suspend: true,
    reactivate: true,
    msgSuspend: 'suspend.success',
    msgReactivate: 'reactivate.success',
  },
  {
    role: 'ROLE_MANAGER',
    restituted: 'No',
    personalizedDate: 'Unset',
    defaultWeek: 'Past',
    outsideCampaign: true,
    updatePDate: false,
    suspend: false,
    reactivate: false,
    msgSuspend: 'suspend.error.pastWeek',
    msgReactivate: 'reactivate.error.campaign',
  },
  {
    role: 'ROLE_MANAGER',
    restituted: 'No',
    personalizedDate: 'Unset',
    defaultWeek: 'Past',
    outsideCampaign: false,
    updatePDate: true,
    suspend: false,
    reactivate: true,
    msgSuspend: 'suspend.error.pastWeek',
    msgReactivate: 'reactivate.dateUnset.success',
  },
  {
    role: 'ROLE_MANAGER',
    restituted: 'No',
    personalizedDate: 'Unset',
    defaultWeek: 'Future',
    outsideCampaign: null,
    updatePDate: false,
    suspend: true,
    reactivate: true,
    msgSuspend: 'suspend.success',
    msgReactivate: 'reactivate.success',
  },
  {
    role: 'ROLE_MANAGER',
    restituted: 'No',
    personalizedDate: 'Past',
    defaultWeek: 'Unset',
    outsideCampaign: true,
    updatePDate: false,
    suspend: false,
    reactivate: false,
    msgSuspend: 'suspend.error.pastDate',
    msgReactivate: 'reactivate.error.campaign',
  },
  {
    role: 'ROLE_MANAGER',
    restituted: 'No',
    personalizedDate: 'Past',
    defaultWeek: 'Unset',
    outsideCampaign: false,
    updatePDate: true,
    suspend: false,
    reactivate: true,
    msgSuspend: 'suspend.error.pastDate',
    msgReactivate: 'reactivate.dateUnset.success',
  },
  {
    role: 'ROLE_MANAGER',
    restituted: 'No',
    personalizedDate: 'Past',
    defaultWeek: 'Past',
    outsideCampaign: true,
    updatePDate: false,
    suspend: false,
    reactivate: false,
    msgSuspend: 'suspend.error.pastDateWeek',
    msgReactivate: 'reactivate.error.campaign',
  },
  {
    role: 'ROLE_MANAGER',
    restituted: 'No',
    personalizedDate: 'Past',
    defaultWeek: 'Past',
    outsideCampaign: false,
    updatePDate: true,
    suspend: false,
    reactivate: true,
    msgSuspend: 'suspend.error.pastDateWeek',
    msgReactivate: 'reactivate.dateUnset.success',
  },
  {
    role: 'ROLE_MANAGER',
    restituted: 'No',
    personalizedDate: 'Past',
    defaultWeek: 'Future',
    outsideCampaign: true,
    updatePDate: false,
    suspend: false,
    reactivate: false,
    msgSuspend: 'suspend.error.pastDate',
    msgReactivate: 'reactivate.error.campaign',
  },
  {
    role: 'ROLE_MANAGER',
    restituted: 'No',
    personalizedDate: 'Past',
    defaultWeek: 'Future',
    outsideCampaign: false,
    updatePDate: true,
    suspend: false,
    reactivate: true,
    msgSuspend: 'suspend.error.pastDate',
    msgReactivate: 'reactivate.dateUnset.success',
  },
  {
    role: 'ROLE_MANAGER',
    restituted: 'No',
    personalizedDate: 'Future',
    defaultWeek: 'Unset',
    outsideCampaign: null,
    updatePDate: false,
    suspend: true,
    reactivate: true,
    msgSuspend: 'suspend.success',
    msgReactivate: 'reactivate.success',
  },
  {
    role: 'ROLE_MANAGER',
    restituted: 'No',
    personalizedDate: 'Future',
    defaultWeek: 'Past',
    outsideCampaign: null,
    updatePDate: false,
    suspend: true,
    reactivate: true,
    msgSuspend: 'suspend.success',
    msgReactivate: 'reactivate.success',
  },
  {
    role: 'ROLE_MANAGER',
    restituted: 'No',
    personalizedDate: 'Future',
    defaultWeek: 'Future',
    outsideCampaign: null,
    updatePDate: false,
    suspend: true,
    reactivate: true,
    msgSuspend: 'suspend.success',
    msgReactivate: 'reactivate.success',
  },
  {
    role: 'ROLE_MANAGER',
    restituted: 'Yes',
    personalizedDate: 'Unset',
    defaultWeek: 'Unset',
    outsideCampaign: null,
    updatePDate: false,
    suspend: false,
    reactivate: false,
    msgSuspend: 'suspend.error.restituted',
    msgReactivate: 'reactivate.error.restituted',
  },
  {
    role: 'ROLE_MANAGER',
    restituted: 'Yes',
    personalizedDate: 'Unset',
    defaultWeek: 'Past',
    outsideCampaign: null,
    updatePDate: false,
    suspend: false,
    reactivate: false,
    msgSuspend: 'suspend.error.restituted.pastWeek',
    msgReactivate: 'reactivate.error.restituted.pastWeek',
  },
  {
    role: 'ROLE_MANAGER',
    restituted: 'Yes',
    personalizedDate: 'Unset',
    defaultWeek: 'Future',
    outsideCampaign: null,
    updatePDate: false,
    suspend: false,
    reactivate: false,
    msgSuspend: 'suspend.error.restituted',
    msgReactivate: 'reactivate.error.restituted',
  },
  {
    role: 'ROLE_MANAGER',
    restituted: 'Yes',
    personalizedDate: 'Past',
    defaultWeek: 'Unset',
    outsideCampaign: null,
    updatePDate: false,
    suspend: false,
    reactivate: false,
    msgSuspend: 'suspend.error.restituted.pastWeek',
    msgReactivate: 'reactivate.error.restituted.pastWeek',
  },
  {
    role: 'ROLE_MANAGER',
    restituted: 'Yes',
    personalizedDate: 'Past',
    defaultWeek: 'Past',
    outsideCampaign: null,
    updatePDate: false,
    suspend: false,
    reactivate: false,
    msgSuspend: 'suspend.error.restituted.pastWeek',
    msgReactivate: 'reactivate.error.restituted.pastWeek',
  },
  {
    role: 'ROLE_MANAGER',
    restituted: 'Yes',
    personalizedDate: 'Past',
    defaultWeek: 'Future',
    outsideCampaign: null,
    updatePDate: false,
    suspend: false,
    reactivate: false,
    msgSuspend: 'suspend.error.restituted.pastWeek',
    msgReactivate: 'reactivate.error.restituted.pastWeek',
  },
  {
    role: 'ROLE_MANAGER',
    restituted: 'Yes',
    personalizedDate: 'Future',
    defaultWeek: 'Unset',
    outsideCampaign: null,
    updatePDate: false,
    suspend: false,
    reactivate: false,
    msgSuspend: 'suspend.error.restituted',
    msgReactivate: 'reactivate.error.restituted',
  },
  {
    role: 'ROLE_MANAGER',
    restituted: 'Yes',
    personalizedDate: 'Future',
    defaultWeek: 'Past',
    outsideCampaign: null,
    updatePDate: false,
    suspend: false,
    reactivate: false,
    msgSuspend: 'suspend.error.restituted',
    msgReactivate: 'reactivate.error.restituted',
  },
  {
    role: 'ROLE_MANAGER',
    restituted: 'Yes',
    personalizedDate: 'Future',
    defaultWeek: 'Future',
    outsideCampaign: null,
    updatePDate: false,
    suspend: false,
    reactivate: false,
    msgSuspend: 'suspend.error.restituted',
    msgReactivate: 'reactivate.error.restituted',
  },

  // ROLE_ADVISOR rules
  {
    role: 'ROLE_ADVISOR',
    restituted: 'No',
    personalizedDate: 'Unset',
    defaultWeek: 'Unset',
    outsideCampaign: null,
    updatePDate: false,
    suspend: true,
    reactivate: true,
    msgSuspend: 'suspend.success',
    msgReactivate: 'reactivate.success',
  },
  {
    role: 'ROLE_ADVISOR',
    restituted: 'No',
    personalizedDate: 'Unset',
    defaultWeek: 'Past',
    outsideCampaign: true,
    updatePDate: false,
    suspend: false,
    reactivate: false,
    msgSuspend: 'suspend.error.pastWeek',
    msgReactivate: 'reactivate.error.campaign',
  },
  {
    role: 'ROLE_ADVISOR',
    restituted: 'No',
    personalizedDate: 'Unset',
    defaultWeek: 'Past',
    outsideCampaign: false,
    updatePDate: true,
    suspend: false,
    reactivate: true,
    msgSuspend: 'suspend.error.pastWeek',
    msgReactivate: 'reactivate.dateUnset.success',
  },
  {
    role: 'ROLE_ADVISOR',
    restituted: 'No',
    personalizedDate: 'Unset',
    defaultWeek: 'Future',
    outsideCampaign: null,
    updatePDate: false,
    suspend: true,
    reactivate: true,
    msgSuspend: 'suspend.success',
    msgReactivate: 'reactivate.success',
  },
  {
    role: 'ROLE_ADVISOR',
    restituted: 'No',
    personalizedDate: 'Past',
    defaultWeek: 'Unset',
    outsideCampaign: true,
    updatePDate: false,
    suspend: false,
    reactivate: false,
    msgSuspend: 'suspend.error.pastDate',
    msgReactivate: 'reactivate.error.campaign',
  },
  {
    role: 'ROLE_ADVISOR',
    restituted: 'No',
    personalizedDate: 'Past',
    defaultWeek: 'Unset',
    outsideCampaign: false,
    updatePDate: true,
    suspend: false,
    reactivate: true,
    msgSuspend: 'suspend.error.pastDate',
    msgReactivate: 'reactivate.dateUnset.success',
  },
  {
    role: 'ROLE_ADVISOR',
    restituted: 'No',
    personalizedDate: 'Past',
    defaultWeek: 'Past',
    outsideCampaign: true,
    updatePDate: false,
    suspend: false,
    reactivate: false,
    msgSuspend: 'suspend.error.pastDateWeek',
    msgReactivate: 'reactivate.error.campaign',
  },
  {
    role: 'ROLE_ADVISOR',
    restituted: 'No',
    personalizedDate: 'Past',
    defaultWeek: 'Past',
    outsideCampaign: false,
    updatePDate: true,
    suspend: false,
    reactivate: true,
    msgSuspend: 'suspend.error.pastDateWeek',
    msgReactivate: 'reactivate.dateUnset.success',
  },
  {
    role: 'ROLE_ADVISOR',
    restituted: 'No',
    personalizedDate: 'Past',
    defaultWeek: 'Future',
    outsideCampaign: true,
    updatePDate: false,
    suspend: false,
    reactivate: false,
    msgSuspend: 'suspend.error.pastDate',
    msgReactivate: 'reactivate.error.campaign',
  },
  {
    role: 'ROLE_ADVISOR',
    restituted: 'No',
    personalizedDate: 'Past',
    defaultWeek: 'Future',
    outsideCampaign: false,
    updatePDate: true,
    suspend: false,
    reactivate: true,
    msgSuspend: 'suspend.error.pastDate',
    msgReactivate: 'reactivate.dateUnset.success',
  },
  {
    role: 'ROLE_ADVISOR',
    restituted: 'No',
    personalizedDate: 'Future',
    defaultWeek: 'Unset',
    outsideCampaign: null,
    updatePDate: false,
    suspend: true,
    reactivate: true,
    msgSuspend: 'suspend.success',
    msgReactivate: 'reactivate.success',
  },
  {
    role: 'ROLE_ADVISOR',
    restituted: 'No',
    personalizedDate: 'Future',
    defaultWeek: 'Past',
    outsideCampaign: null,
    updatePDate: false,
    suspend: true,
    reactivate: true,
    msgSuspend: 'suspend.success',
    msgReactivate: 'reactivate.success',
  },
  {
    role: 'ROLE_ADVISOR',
    restituted: 'No',
    personalizedDate: 'Future',
    defaultWeek: 'Future',
    outsideCampaign: null,
    updatePDate: false,
    suspend: true,
    reactivate: true,
    msgSuspend: 'suspend.success',
    msgReactivate: 'reactivate.success',
  },
  {
    role: 'ROLE_ADVISOR',
    restituted: 'Yes',
    personalizedDate: 'Unset',
    defaultWeek: 'Unset',
    outsideCampaign: null,
    updatePDate: false,
    suspend: false,
    reactivate: false,
    msgSuspend: 'suspend.error.restituted',
    msgReactivate: 'reactivate.error.restituted',
  },
  {
    role: 'ROLE_ADVISOR',
    restituted: 'Yes',
    personalizedDate: 'Unset',
    defaultWeek: 'Past',
    outsideCampaign: null,
    updatePDate: false,
    suspend: false,
    reactivate: false,
    msgSuspend: 'suspend.error.restituted.pastWeek',
    msgReactivate: 'reactivate.error.restituted.pastWeek',
  },
  {
    role: 'ROLE_ADVISOR',
    restituted: 'Yes',
    personalizedDate: 'Unset',
    defaultWeek: 'Future',
    outsideCampaign: null,
    updatePDate: false,
    suspend: false,
    reactivate: false,
    msgSuspend: 'suspend.error.restituted',
    msgReactivate: 'reactivate.error.restituted',
  },
  {
    role: 'ROLE_ADVISOR',
    restituted: 'Yes',
    personalizedDate: 'Past',
    defaultWeek: 'Unset',
    outsideCampaign: null,
    updatePDate: false,
    suspend: false,
    reactivate: false,
    msgSuspend: 'suspend.error.restituted.pastWeek',
    msgReactivate: 'reactivate.error.restituted.pastWeek',
  },
  {
    role: 'ROLE_ADVISOR',
    restituted: 'Yes',
    personalizedDate: 'Past',
    defaultWeek: 'Past',
    outsideCampaign: null,
    updatePDate: false,
    suspend: false,
    reactivate: false,
    msgSuspend: 'suspend.error.restituted.pastWeek',
    msgReactivate: 'reactivate.error.restituted.pastWeek',
  },
  {
    role: 'ROLE_ADVISOR',
    restituted: 'Yes',
    personalizedDate: 'Past',
    defaultWeek: 'Future',
    outsideCampaign: null,
    updatePDate: false,
    suspend: false,
    reactivate: false,
    msgSuspend: 'suspend.error.restituted.pastWeek',
    msgReactivate: 'reactivate.error.restituted.pastWeek',
  },
  {
    role: 'ROLE_ADVISOR',
    restituted: 'Yes',
    personalizedDate: 'Future',
    defaultWeek: 'Unset',
    outsideCampaign: null,
    updatePDate: false,
    suspend: false,
    reactivate: false,
    msgSuspend: 'suspend.error.restituted',
    msgReactivate: 'reactivate.error.restituted',
  },
  {
    role: 'ROLE_ADVISOR',
    restituted: 'Yes',
    personalizedDate: 'Future',
    defaultWeek: 'Past',
    outsideCampaign: null,
    updatePDate: false,
    suspend: false,
    reactivate: false,
    msgSuspend: 'suspend.error.restituted',
    msgReactivate: 'reactivate.error.restituted',
  },
  {
    role: 'ROLE_ADVISOR',
    restituted: 'Yes',
    personalizedDate: 'Future',
    defaultWeek: 'Future',
    outsideCampaign: null,
    updatePDate: false,
    suspend: false,
    reactivate: false,
    msgSuspend: 'suspend.error.restituted',
    msgReactivate: 'reactivate.error.restituted',
  },

  // ROLE_FARMER rules
  {
    role: 'ROLE_FARMER',
    restituted: 'No',
    personalizedDate: 'Unset',
    defaultWeek: 'Unset',
    outsideCampaign: null,
    updatePDate: false,
    suspend: true,
    reactivate: true,
    msgSuspend: 'suspend.success',
    msgReactivate: 'reactivate.success',
  },
  {
    role: 'ROLE_FARMER',
    restituted: 'No',
    personalizedDate: 'Unset',
    defaultWeek: 'Past',
    outsideCampaign: true,
    updatePDate: false,
    suspend: false,
    reactivate: false,
    msgSuspend: 'suspend.error.pastWeek',
    msgReactivate: 'reactivate.error.campaign',
  },
  {
    role: 'ROLE_FARMER',
    restituted: 'No',
    personalizedDate: 'Unset',
    defaultWeek: 'Past',
    outsideCampaign: false,
    updatePDate: true,
    suspend: false,
    reactivate: true,
    msgSuspend: 'suspend.error.pastWeek',
    msgReactivate: 'reactivate.dateUnset.success',
  },
  {
    role: 'ROLE_FARMER',
    restituted: 'No',
    personalizedDate: 'Unset',
    defaultWeek: 'Future',
    outsideCampaign: null,
    updatePDate: false,
    suspend: true,
    reactivate: true,
    msgSuspend: 'suspend.success',
    msgReactivate: 'reactivate.success',
  },
  {
    role: 'ROLE_FARMER',
    restituted: 'No',
    personalizedDate: 'Past',
    defaultWeek: 'Unset',
    outsideCampaign: true,
    updatePDate: false,
    suspend: false,
    reactivate: false,
    msgSuspend: 'suspend.error.pastDate',
    msgReactivate: 'reactivate.error.campaign',
  },
  {
    role: 'ROLE_FARMER',
    restituted: 'No',
    personalizedDate: 'Past',
    defaultWeek: 'Unset',
    outsideCampaign: false,
    updatePDate: true,
    suspend: false,
    reactivate: true,
    msgSuspend: 'suspend.error.pastDate',
    msgReactivate: 'reactivate.dateUnset.success',
  },
  {
    role: 'ROLE_FARMER',
    restituted: 'No',
    personalizedDate: 'Past',
    defaultWeek: 'Past',
    outsideCampaign: true,
    updatePDate: false,
    suspend: false,
    reactivate: false,
    msgSuspend: 'suspend.error.pastDateWeek',
    msgReactivate: 'reactivate.error.campaign',
  },
  {
    role: 'ROLE_FARMER',
    restituted: 'No',
    personalizedDate: 'Past',
    defaultWeek: 'Past',
    outsideCampaign: false,
    updatePDate: true,
    suspend: false,
    reactivate: true,
    msgSuspend: 'suspend.error.pastDateWeek',
    msgReactivate: 'reactivate.dateUnset.success',
  },
  {
    role: 'ROLE_FARMER',
    restituted: 'No',
    personalizedDate: 'Past',
    defaultWeek: 'Future',
    outsideCampaign: true,
    updatePDate: false,
    suspend: false,
    reactivate: false,
    msgSuspend: 'suspend.error.pastDate',
    msgReactivate: 'reactivate.error.campaign',
  },
  {
    role: 'ROLE_FARMER',
    restituted: 'No',
    personalizedDate: 'Past',
    defaultWeek: 'Future',
    outsideCampaign: false,
    updatePDate: true,
    suspend: false,
    reactivate: true,
    msgSuspend: 'suspend.error.pastDate',
    msgReactivate: 'reactivate.dateUnset.success',
  },
  {
    role: 'ROLE_FARMER',
    restituted: 'No',
    personalizedDate: 'Future',
    defaultWeek: 'Unset',
    outsideCampaign: null,
    updatePDate: false,
    suspend: true,
    reactivate: true,
    msgSuspend: 'suspend.success',
    msgReactivate: 'reactivate.success',
  },
  {
    role: 'ROLE_FARMER',
    restituted: 'No',
    personalizedDate: 'Future',
    defaultWeek: 'Past',
    outsideCampaign: null,
    updatePDate: false,
    suspend: true,
    reactivate: true,
    msgSuspend: 'suspend.success',
    msgReactivate: 'reactivate.success',
  },
  {
    role: 'ROLE_FARMER',
    restituted: 'No',
    personalizedDate: 'Future',
    defaultWeek: 'Future',
    outsideCampaign: null,
    updatePDate: false,
    suspend: true,
    reactivate: true,
    msgSuspend: 'suspend.success',
    msgReactivate: 'reactivate.success',
  },
  {
    role: 'ROLE_FARMER',
    restituted: 'Yes',
    personalizedDate: 'Unset',
    defaultWeek: 'Unset',
    outsideCampaign: null,
    updatePDate: false,
    suspend: false,
    reactivate: false,
    msgSuspend: 'suspend.error.restituted',
    msgReactivate: 'reactivate.error.restituted',
  },
  {
    role: 'ROLE_FARMER',
    restituted: 'Yes',
    personalizedDate: 'Unset',
    defaultWeek: 'Past',
    outsideCampaign: null,
    updatePDate: false,
    suspend: false,
    reactivate: false,
    msgSuspend: 'suspend.error.restituted.pastWeek',
    msgReactivate: 'reactivate.error.restituted.pastWeek',
  },
  {
    role: 'ROLE_FARMER',
    restituted: 'Yes',
    personalizedDate: 'Unset',
    defaultWeek: 'Future',
    outsideCampaign: null,
    updatePDate: false,
    suspend: false,
    reactivate: false,
    msgSuspend: 'suspend.error.restituted',
    msgReactivate: 'reactivate.error.restituted',
  },
  {
    role: 'ROLE_FARMER',
    restituted: 'Yes',
    personalizedDate: 'Past',
    defaultWeek: 'Unset',
    outsideCampaign: null,
    updatePDate: false,
    suspend: false,
    reactivate: false,
    msgSuspend: 'suspend.error.restituted.pastWeek',
    msgReactivate: 'reactivate.error.restituted.pastWeek',
  },
  {
    role: 'ROLE_FARMER',
    restituted: 'Yes',
    personalizedDate: 'Past',
    defaultWeek: 'Past',
    outsideCampaign: null,
    updatePDate: false,
    suspend: false,
    reactivate: false,
    msgSuspend: 'suspend.error.restituted.pastWeek',
    msgReactivate: 'reactivate.error.restituted.pastWeek',
  },
  {
    role: 'ROLE_FARMER',
    restituted: 'Yes',
    personalizedDate: 'Past',
    defaultWeek: 'Future',
    outsideCampaign: null,
    updatePDate: false,
    suspend: false,
    reactivate: false,
    msgSuspend: 'suspend.error.restituted.pastWeek',
    msgReactivate: 'reactivate.error.restituted.pastWeek',
  },
  {
    role: 'ROLE_FARMER',
    restituted: 'Yes',
    personalizedDate: 'Future',
    defaultWeek: 'Unset',
    outsideCampaign: null,
    updatePDate: false,
    suspend: false,
    reactivate: false,
    msgSuspend: 'suspend.error.restituted',
    msgReactivate: 'reactivate.error.restituted',
  },
  {
    role: 'ROLE_FARMER',
    restituted: 'Yes',
    personalizedDate: 'Future',
    defaultWeek: 'Past',
    outsideCampaign: null,
    updatePDate: false,
    suspend: false,
    reactivate: false,
    msgSuspend: 'suspend.error.restituted',
    msgReactivate: 'reactivate.error.restituted',
  },
  {
    role: 'ROLE_FARMER',
    restituted: 'Yes',
    personalizedDate: 'Future',
    defaultWeek: 'Future',
    outsideCampaign: null,
    updatePDate: false,
    suspend: false,
    reactivate: false,
    msgSuspend: 'suspend.error.restituted',
    msgReactivate: 'reactivate.error.restituted',
  },

  // ROLE_SECTOR rules
  {
    role: 'ROLE_SECTOR',
    restituted: 'No',
    personalizedDate: 'Unset',
    defaultWeek: 'Unset',
    outsideCampaign: null,
    updatePDate: false,
    suspend: true,
    reactivate: true,
    msgSuspend: 'suspend.success',
    msgReactivate: 'reactivate.success',
  },
  {
    role: 'ROLE_SECTOR',
    restituted: 'No',
    personalizedDate: 'Unset',
    defaultWeek: 'Past',
    outsideCampaign: true,
    updatePDate: false,
    suspend: false,
    reactivate: false,
    msgSuspend: 'suspend.error.pastWeek',
    msgReactivate: 'reactivate.error.campaign',
  },
  {
    role: 'ROLE_SECTOR',
    restituted: 'No',
    personalizedDate: 'Unset',
    defaultWeek: 'Past',
    outsideCampaign: false,
    updatePDate: true,
    suspend: false,
    reactivate: true,
    msgSuspend: 'suspend.error.pastWeek',
    msgReactivate: 'reactivate.dateUnset.success',
  },
  {
    role: 'ROLE_SECTOR',
    restituted: 'No',
    personalizedDate: 'Unset',
    defaultWeek: 'Future',
    outsideCampaign: null,
    updatePDate: false,
    suspend: true,
    reactivate: true,
    msgSuspend: 'suspend.success',
    msgReactivate: 'reactivate.success',
  },
  {
    role: 'ROLE_SECTOR',
    restituted: 'No',
    personalizedDate: 'Past',
    defaultWeek: 'Unset',
    outsideCampaign: true,
    updatePDate: false,
    suspend: false,
    reactivate: false,
    msgSuspend: 'suspend.error.pastDate',
    msgReactivate: 'reactivate.error.campaign',
  },
  {
    role: 'ROLE_SECTOR',
    restituted: 'No',
    personalizedDate: 'Past',
    defaultWeek: 'Unset',
    outsideCampaign: false,
    updatePDate: true,
    suspend: false,
    reactivate: true,
    msgSuspend: 'suspend.error.pastDate',
    msgReactivate: 'reactivate.dateUnset.success',
  },
  {
    role: 'ROLE_SECTOR',
    restituted: 'No',
    personalizedDate: 'Past',
    defaultWeek: 'Past',
    outsideCampaign: true,
    updatePDate: false,
    suspend: false,
    reactivate: false,
    msgSuspend: 'suspend.error.pastDateWeek',
    msgReactivate: 'reactivate.error.campaign',
  },
  {
    role: 'ROLE_SECTOR',
    restituted: 'No',
    personalizedDate: 'Past',
    defaultWeek: 'Past',
    outsideCampaign: false,
    updatePDate: true,
    suspend: false,
    reactivate: true,
    msgSuspend: 'suspend.error.pastDateWeek',
    msgReactivate: 'reactivate.dateUnset.success',
  },
  {
    role: 'ROLE_SECTOR',
    restituted: 'No',
    personalizedDate: 'Past',
    defaultWeek: 'Future',
    outsideCampaign: true,
    updatePDate: false,
    suspend: false,
    reactivate: false,
    msgSuspend: 'suspend.error.pastDate',
    msgReactivate: 'reactivate.error.campaign',
  },
  {
    role: 'ROLE_SECTOR',
    restituted: 'No',
    personalizedDate: 'Past',
    defaultWeek: 'Future',
    outsideCampaign: false,
    updatePDate: true,
    suspend: false,
    reactivate: true,
    msgSuspend: 'suspend.error.pastDate',
    msgReactivate: 'reactivate.dateUnset.success',
  },
  {
    role: 'ROLE_SECTOR',
    restituted: 'No',
    personalizedDate: 'Future',
    defaultWeek: 'Unset',
    outsideCampaign: null,
    updatePDate: false,
    suspend: true,
    reactivate: true,
    msgSuspend: 'suspend.success',
    msgReactivate: 'reactivate.success',
  },
  {
    role: 'ROLE_SECTOR',
    restituted: 'No',
    personalizedDate: 'Future',
    defaultWeek: 'Past',
    outsideCampaign: null,
    updatePDate: false,
    suspend: true,
    reactivate: true,
    msgSuspend: 'suspend.success',
    msgReactivate: 'reactivate.success',
  },
  {
    role: 'ROLE_SECTOR',
    restituted: 'No',
    personalizedDate: 'Future',
    defaultWeek: 'Future',
    outsideCampaign: null,
    updatePDate: false,
    suspend: true,
    reactivate: true,
    msgSuspend: 'suspend.success',
    msgReactivate: 'reactivate.success',
  },
  {
    role: 'ROLE_SECTOR',
    restituted: 'Yes',
    personalizedDate: 'Unset',
    defaultWeek: 'Unset',
    outsideCampaign: null,
    updatePDate: false,
    suspend: false,
    reactivate: false,
    msgSuspend: 'suspend.error.restituted',
    msgReactivate: 'reactivate.error.restituted',
  },
  {
    role: 'ROLE_SECTOR',
    restituted: 'Yes',
    personalizedDate: 'Unset',
    defaultWeek: 'Past',
    outsideCampaign: null,
    updatePDate: false,
    suspend: false,
    reactivate: false,
    msgSuspend: 'suspend.error.restituted.pastWeek',
    msgReactivate: 'reactivate.error.restituted.pastWeek',
  },
  {
    role: 'ROLE_SECTOR',
    restituted: 'Yes',
    personalizedDate: 'Unset',
    defaultWeek: 'Future',
    outsideCampaign: null,
    updatePDate: false,
    suspend: false,
    reactivate: false,
    msgSuspend: 'suspend.error.restituted',
    msgReactivate: 'reactivate.error.restituted',
  },
  {
    role: 'ROLE_SECTOR',
    restituted: 'Yes',
    personalizedDate: 'Past',
    defaultWeek: 'Unset',
    outsideCampaign: null,
    updatePDate: false,
    suspend: false,
    reactivate: false,
    msgSuspend: 'suspend.error.restituted.pastWeek',
    msgReactivate: 'reactivate.error.restituted.pastWeek',
  },
  {
    role: 'ROLE_SECTOR',
    restituted: 'Yes',
    personalizedDate: 'Past',
    defaultWeek: 'Past',
    outsideCampaign: null,
    updatePDate: false,
    suspend: false,
    reactivate: false,
    msgSuspend: 'suspend.error.restituted.pastWeek',
    msgReactivate: 'reactivate.error.restituted.pastWeek',
  },
  {
    role: 'ROLE_SECTOR',
    restituted: 'Yes',
    personalizedDate: 'Past',
    defaultWeek: 'Future',
    outsideCampaign: null,
    updatePDate: false,
    suspend: false,
    reactivate: false,
    msgSuspend: 'suspend.error.restituted.pastWeek',
    msgReactivate: 'reactivate.error.restituted.pastWeek',
  },
  {
    role: 'ROLE_SECTOR',
    restituted: 'Yes',
    personalizedDate: 'Future',
    defaultWeek: 'Unset',
    outsideCampaign: null,
    updatePDate: false,
    suspend: false,
    reactivate: false,
    msgSuspend: 'suspend.error.restituted',
    msgReactivate: 'reactivate.error.restituted',
  },
  {
    role: 'ROLE_SECTOR',
    restituted: 'Yes',
    personalizedDate: 'Future',
    defaultWeek: 'Past',
    outsideCampaign: null,
    updatePDate: false,
    suspend: false,
    reactivate: false,
    msgSuspend: 'suspend.error.restituted',
    msgReactivate: 'reactivate.error.restituted',
  },
  {
    role: 'ROLE_SECTOR',
    restituted: 'Yes',
    personalizedDate: 'Future',
    defaultWeek: 'Future',
    outsideCampaign: null,
    updatePDate: false,
    suspend: false,
    reactivate: false,
    msgSuspend: 'suspend.error.restituted',
    msgReactivate: 'reactivate.error.restituted',
  },
];

function getRuleForContext(ctx) {
  return rules.find(function (rule) {
    return (
      rule.role === ctx.role &&
      rule.restituted === ctx.restituted &&
      rule.personalizedDate === ctx.personalizedDate &&
      rule.defaultWeek === ctx.defaultWeek &&
      (rule.outsideCampaign === null || rule.outsideCampaign === ctx.outsideCampaign)
    );
  });
}

function canSuspendParcel(ctx) {
  const rule = getRuleForContext(ctx);

  return rule
    ? { allowed: rule.suspend, messageKey: `planning.${rule.msgSuspend}`, updatePDate: rule.updatePDate }
    : { allowed: false, messageKey: 'planning.suspend.unknownRule', updatePDate: false };
}

function canReactivateParcel(ctx) {
  const rule = getRuleForContext(ctx);
  return rule
    ? { allowed: rule.reactivate, messageKey: `planning.${rule.msgReactivate}`, updatePDate: rule.updatePDate }
    : { allowed: false, messageKey: 'planning.reactivate.unknownRule', updatePDate: false };
}

export function canSuspendParcelFunc(role, parcel, culture, passage, campaignYear?: number) {
  const restituted = isAdviceDelivered(parcel, culture, passage) ? 'Yes' : 'No';
  const parcelPersonalizedDate = getDate(parcel, culture, passage);
  const personalizedDate = getDateState(parcelPersonalizedDate, campaignYear);
  const defaultWeek = getDefaultWeekDateState(parcel, culture, passage, campaignYear);
  const outsideCampaignFlag = isOutsideCampaign(parcel, culture, passage, campaignYear);

  const ctx = {
    role: role,
    restituted: restituted,
    personalizedDate: personalizedDate,
    defaultWeek: defaultWeek,
    outsideCampaign: outsideCampaignFlag,
  };
  return canSuspendParcel(ctx);
}

export function canReactivateParcelFunc(role, parcel, culture, passage, campaignYear: number) {
  const restituted = isAdviceDelivered(parcel, culture, passage) ? 'Yes' : 'No';
  const parcelPersonalizedDate = getDate(parcel, culture, passage);
  const personalizedDate = getDateState(parcelPersonalizedDate, campaignYear);
  const defaultWeek = getDefaultWeekDateState(parcel, culture, passage, campaignYear);
  const outsideCampaignFlag = isOutsideCampaign(parcel, culture, passage, campaignYear);

  const ctx = {
    role: role,
    restituted: restituted,
    personalizedDate: personalizedDate,
    defaultWeek: defaultWeek,
    outsideCampaign: outsideCampaignFlag,
  };
  return canReactivateParcel(ctx);
}

function getDateState(date, campaignYear: number) {
  if (!date) return 'Unset';
  const d = typeof date === 'string' ? new Date(date) : date;
  if (isNaN(d.getTime())) return 'Unset';
  const now = todayInCampaignYear(campaignYear);
  if (d < now) return 'Past';
  return 'Future';
}

function getDate(parcel: any, culture: string, passage: string) {
  if (parcel.orderItem) {
    switch (culture) {
      case 'ble':
        switch (passage) {
          case 'BLET1':
            if (parcel.orderItem.t1_date_livraison) {
              return parcel.orderItem.t1_date_livraison;
            } else {
              return null;
            }
          case 'BLET2':
            if (parcel.orderItem.t2_date_livraison) {
              return parcel.orderItem.t2_date_livraison;
            } else {
              return null;
            }
          case 'BLEDN':
            if (parcel.orderItem.dn_date_livraison) {
              return parcel.orderItem.dn_date_livraison;
            } else {
              return null;
            }
          case 'BLET3':
            if (parcel.orderItem.t3_date_livraison) {
              return parcel.orderItem.t3_date_livraison;
            } else {
              return null;
            }
        }
        break;
      case 'orge':
        switch (passage) {
          case 'ORGET2':
            if (parcel.orderItem.t2_date_livraison) {
              return parcel.orderItem.t2_date_livraison;
            } else {
              return null;
            }
          case 'ORGET3':
            if (parcel.orderItem.t3_date_livraison) {
              return parcel.orderItem.t3_date_livraison;
            } else {
              return null;
            }
        }
        break;
      case 'colza':
        switch (passage) {
          case 'COLZASH':
            if (parcel.orderItem.sh_date_livraison) {
              return parcel.orderItem.sh_date_livraison;
            } else {
              return null;
            }
          case 'COLZAEH':
            if (parcel.orderItem.eh_date_livraison) {
              return parcel.orderItem.eh_date_livraison;
            } else {
              return null;
            }
        }
        break;
      default:
        return null;
    }
  } else {
    return null;
  }
}

function hasWeekPassed(weekNumber, campaignYear: number) {
  const currentYear = new Date().getFullYear();

  if (campaignYear > currentYear) {
    return false;
  }

  if (campaignYear < currentYear) {
    return true;
  }

  const currentWeek = getCurrentWeekNumber(campaignYear); // Sin parámetro, usa año actual
  return weekNumber < currentWeek;
}

function getCurrentWeekNumber(campaignYear: number) {
  const date = todayInCampaignYear(campaignYear);
  const target = new Date(date.valueOf());
  const dayOfWeek = (date.getDay() + 6) % 7;
  target.setDate(target.getDate() - dayOfWeek + 3);
  const firstThursday = new Date(target.getFullYear(), 0, 4);
  const daysDiff = Math.floor((target.getTime() - firstThursday.getTime()) / (24 * 60 * 60 * 1000));
  return Math.floor(daysDiff / 7) + 1;
}

function getDefaultWeekDateState(parcel, culture, passage, campaignYear: number) {
  const defaultWeekNumber = getDefaultWeek(parcel, culture, passage);
  if (defaultWeekNumber == null || defaultWeekNumber === 0) return 'Unset';
  if (hasWeekPassed(defaultWeekNumber, campaignYear)) {
    return 'Past';
  }
  return 'Future';
}

function getDefaultWeek(parcel: any, culture: string, passage: string): number {
  if (parcel.orderItem) {
    switch (culture) {
      case 'ble':
        switch (passage) {
          case 'BLET1':
            return parcel.orderItem.defaultWeekT1 && parcel.orderItem.defaultWeekT1.week
              ? parcel.orderItem.defaultWeekT1.week
              : 0;
          case 'BLET2':
            return parcel.orderItem.defaultWeekT2 && parcel.orderItem.defaultWeekT2.week
              ? parcel.orderItem.defaultWeekT2.week
              : 0;
          case 'BLEDN':
            return parcel.orderItem.defaultWeekDn && parcel.orderItem.defaultWeekDn.week
              ? parcel.orderItem.defaultWeekDn.week
              : 0;
          case 'BLET3':
            return parcel.orderItem.defaultWeekT3 && parcel.orderItem.defaultWeekT3.week
              ? parcel.orderItem.defaultWeekT3.week
              : 0;
        }
        break;
      case 'orge':
        switch (passage) {
          case 'ORGET2':
            return parcel.orderItem.defaultWeekT2 && parcel.orderItem.defaultWeekT2.week
              ? parcel.orderItem.defaultWeekT2.week
              : 0;
          case 'ORGET3':
            return parcel.orderItem.defaultWeekT3 && parcel.orderItem.defaultWeekT3.week
              ? parcel.orderItem.defaultWeekT3.week
              : 0;
        }
        break;
      case 'colza':
        switch (passage) {
          case 'COLZASH':
            return parcel.orderItem.defaultWeek && parcel.orderItem.defaultWeek.week
              ? parcel.orderItem.defaultWeek.week
              : 0;
          case 'COLZAEH':
            return parcel.orderItem.defaultWeek && parcel.orderItem.defaultWeek.week
              ? parcel.orderItem.defaultWeek.week
              : 0;
        }
        break;
      default:
        return 0;
    }
  }
  return 0;
}

function isAdviceDelivered(parcel, culture, passage) {
  if (!parcel || !parcel.results || !parcel.results.length) {
    return false;
  }
  let expectedResultTypeId = 0;
  switch (culture) {
    case 'ble':
      switch (passage) {
        case 'BLET1':
          expectedResultTypeId = 8;
          break;
        case 'BLET2':
          expectedResultTypeId = 1;
          break;
        case 'BLEDN':
          expectedResultTypeId = 16;
          break;
        case 'BLET3':
          expectedResultTypeId = 2;
          break;
      }
      break;
    case 'orge':
      switch (passage) {
        case 'ORGET2':
          expectedResultTypeId = 1;
          break;
        case 'ORGET3':
          expectedResultTypeId = 5;
          break;
      }
      break;
    case 'colza':
      switch (passage) {
        case 'COLZASH':
          expectedResultTypeId = 2;
          break;
      }
      break;
    default:
      return false;
  }

  const result = parcel.results.find(function (res) {
    return res.resultType.id === expectedResultTypeId && res.isValidated === true;
  });

  return !!result;
}

function getDateRangeOfISOWeek(week: number, year: number) {
  // Calculate a date within that week
  const simple = new Date(year, 0, 1 + (week - 1) * 7);
  const dow = simple.getDay(); // 0 = Sunday ... 6 = Saturday

  // Shift back to Monday
  const dayShift = dow <= 4 ? dow - 1 : dow - 8;
  const weekStart = new Date(simple.getTime());
  weekStart.setDate(simple.getDate() - dayShift);
  weekStart.setHours(0, 0, 0, 0);

  // End of the week = Monday + 6 days
  const weekEnd = new Date(weekStart.getTime());
  weekEnd.setDate(weekStart.getDate() + 6);
  weekEnd.setHours(23, 59, 59, 999);

  return { start: weekStart, end: weekEnd };
}

function isOutsideCampaign(parcel: any, culture: string, passage: string, campaignYearParam?: number): boolean {
  // Get today at midnight
  const today = todayInCampaignYear(campaignYear);
  today.setHours(0, 0, 0, 0);

  // Use current year for campaign boundsi
  var campaignYear = today.getFullYear();
  if (campaignYearParam) {
    campaignYear = campaignYearParam;
  }

  // Initialize start/end
  let campaignStart = null;
  let campaignEnd = null;

  // Define campaign window based on culture & passage
  switch (culture.toLowerCase()) {
    case 'ble':
      switch (passage.toUpperCase()) {
        case 'BLET1':
          campaignStart = new Date(campaignYear, 0, 2); // Jan 2
          campaignEnd = new Date(campaignYear, 2, 31); // Mar 31
          break;
        case 'BLET2':
          campaignStart = new Date(campaignYear, 0, 2); // Jan 2
          campaignEnd = new Date(campaignYear, 5, 15); // Jun 15
          break;
        case 'BLEDN':
        case 'BLET3':
          campaignStart = new Date(campaignYear, 2, 14); // Mar 14
          campaignEnd = new Date(campaignYear, 5, 15); // Jun 15
          break;
      }
      break;

    case 'orge':
      switch (passage.toUpperCase()) {
        case 'ORGET2':
        case 'ORGET3':
          campaignStart = new Date(campaignYear, 0, 2); // Jan 2
          campaignEnd = new Date(campaignYear, 5, 15); // Jun 15
          break;
      }
      break;

    case 'colza':
      switch (passage.toUpperCase()) {
        case 'COLZASH':
        case 'COLZAEH':
          campaignStart = new Date(campaignYear, 1, 5); // Feb 5
          campaignEnd = new Date(campaignYear, 4, 15); // May 15
          break;
      }
      break;

    default:
      console.error('No configuration found for culture: ' + culture + ', passage: ' + passage);
      // If we don't know the campaign, treat it as outside
      return true;
  }

  // If start/end are missing, log and consider outside
  if (!campaignStart || !campaignEnd) {
    console.error('Missing campaign dates for culture: ' + culture + ', passage: ' + passage);
    return true;
  }

  // Return true if today is before start or after end
  return today < campaignStart || today > campaignEnd;
}

function todayInCampaignYear(campaignYear?: number): Date {
  const realToday = new Date();
  if (!campaignYear || Number.isNaN(+campaignYear)) return realToday;

  const month = realToday.getMonth();
  let day = realToday.getDate();

  // Adjust Leap year
  const isLeap = (y: number) => (y % 4 === 0 && y % 100 !== 0) || y % 400 === 0;
  if (month === 1 && day === 29 && !isLeap(campaignYear)) day = 28;

  const d = new Date(campaignYear, month, day);
  d.setHours(0, 0, 0, 0);
  return d;
}
